
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ColumnApi, GetRowIdParams, GridApi, GridOptions, GridReadyEvent } from "ag-grid-community";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppCoreService } from "src/app/services/app-core.service";
import Swal from "sweetalert2";
import { SalesInvoiceService } from "src/app/services/misc/sales/sales.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { InvoiceDeleteActionsRenderer } from "../../shared/ag-grid/cell-renderers/invoice-delete.componet";
import { CheckboxCellComponent } from "../../shared/ag-grid/cell-renderers/checkbox-cell.component";
import { CompanyService } from "src/app/services/company.service";
import { NetworkService } from "src/app/services/network.service";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { MiscService } from "src/app/services/misc/misc.service";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";

@Component({
    selector: "app-invoice-series",
    templateUrl: './invoiceseries.component.html',
    styleUrls: ['./invoiceseries.component.scss']
})

export class InvoiceSeriesComponent implements OnInit, AfterViewInit {
    invoiceFormatsForm: FormGroup;
    invoiceIRNForm: FormGroup;
    configForm: FormGroup;
    irnFromSubmitted = false
    activeTab = 1;
    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    filteredRows = [];
    isAllGridDataLoaded = false;
    isFormSubmitted = false;
    isInvoiceConfigFormSubmitted = false;
    invoiceConfigData: any[] = [];

    configType = ["Prefix", "Suffix"];
    codeType = ["Country Code", "Company Code", "ServiceCenter Code", "Year", "Custom"];
    separatorValue = ["/", "-"];
    sequenceNo = [1, 2, 3];

    billToList = [{ name: 'Company' }, { name: 'Service Center' }];
    companyList = []
    serviceCenterList = []
    invoiceConfigDetails: any[] = [];

    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;

    defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight'
    }

    invoiceConfigColumnDefs = [
        { headerName: 'Code', field: 'code' },
        { headerName: 'Custom Value', field: 'customvalue' },
        { headerName: 'Separator', field: 'separator' },
        { headerName: 'Sequence', field: 'sequence' },
        {
            headerName: 'Actions',
            field: 'id',
            cellRenderer: InvoiceDeleteActionsRenderer,
            cellClass: "actions-button-cell",
            cellStyle: { "overflow": 'visible' },
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
            filter: false
        },
    ];

    invoiceColumnDefs = [
        { headerName: 'Company', field: 'company' },
        { headerName: 'Service Center', field: 'servicecenter' },
        { headerName: 'Invoice Type', field: 'invoicetype' },
        { headerName: 'Start From', field: 'startfrom' },
        { headerName: 'Prefix', field: 'prefix' },
        { headerName: 'Suffix', field: 'suffix' },
        { headerName: 'Active', field: 'isactive', cellRenderer: CheckboxCellComponent },
        {
            headerName: 'Actions',
            field: 'id',
            cellRenderer: InvoiceDeleteActionsRenderer,
            cellClass: "actions-button-cell",
            cellStyle: { "overflow": 'visible' },
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
            filter: false
        },
    ]

    irnColumnDefs = [
        // { headerName: 'Vendor', field: 'vendor' },
        { headerName: 'Bill to', field: 'billto' },
        { headerName: 'Company', field: 'company', cellStyle: { textAlign: 'center' } },
        { headerName: 'Service Center', field: 'servicecenter', cellStyle: { textAlign: 'center' } },
        { headerName: 'UserId', field: 'userid' },
        { headerName: 'Password', field: 'password' },
        {
            headerName: 'Actions',
            field: 'id',
            cellRenderer: InvoiceDeleteActionsRenderer,
            cellClass: "actions-button-cell",
            cellStyle: { "overflow": 'visible' },
            colId: 'params',
            editable: false,
            sortable: false,
            minWidth: 150,
            filter: false
        },
    ];
    rowDataIRN = [];
    invoiceTypeList = [];
    invoiceConfigRowData = [];
    invoiceRowData = [];
    activeInvoiceSeriesId: number;

    isIRNBillingToCompany = true;
    isInvoiceBillingToSC = false;

    isEditIrnMode = false;
    irnId: number;
    configDetail: any;
    useEnterKey: any;
    constructor(
        private formBuilder: FormBuilder,
        private appCoreService: AppCoreService,
        private ngxLoaderService: NgxUiLoaderService,
        private invoiceService: SalesInvoiceService,
        private companyService: CompanyService,
        private networkService: NetworkService,
        private configService: ConfigService,
        private miscService: MiscService,
        private titleService: Title,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Invoice Series');
        this.context = { componentParent: this, componentName: 'InvoiceSeriesComponent' }
    }

    ngOnInit(): void {
        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
        this.invoiceFormatsForm = this.formBuilder.group({
            ddlInvoiceType: [null, Validators.required],
            txtStartFrom: [null, Validators.required],
            ddlCompany: [null, Validators.required],
            ddlServiceCenter: [null],
            txtActive: [true],
            invoiceConfigForm: this.formBuilder.group({
                ddlConfig: ['Prefix', Validators.required],
                ddlCode: ['Year', Validators.required],
                txtCustom: [null],
                ddlSeparator: ['/'],
                ddlSequence: [1, Validators.required]
            })
        });

        this.invoiceIRNForm = this.formBuilder.group({
            ddlBillTo: [this.billToList[0].name, Validators.required],
            ddlCompany: [null, Validators.required],
            ddlServiceCenter: [null],
            txtUserId: [null, Validators.required],
            txtPassword: [null, Validators.required]
        })

        this.configForm = this.formBuilder.group({
            configDetails: this.formBuilder.array([])
        })
        this.checkPermission();
        if (this.permConfig.isViewAllowed) {
            this.bindInvoiceType();
            this.bindInvoiceSeries();
            this.getAllCompanies();
            this.getAllServiceCenter();
            this.onBillToChange();
            this.GetAllIrnConfig();
            this.bindInvoiceConfigs();
        }
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.invoiceFormatsForm) : null;
    }

    bindInvoiceConfigs() {
        this.miscService.GetMasterConfigs('INVOICE').subscribe(res => {
            if (res?.success) {
                this.configDetail = res?.data ?? [];
                this.updateConfigForm();
                this.bindConfig();
            }
        })
    }

    updateConfigForm() {
        const configDetailsArray = this.configForm.get('configDetails') as FormArray;
        configDetailsArray.clear();
        this.configDetail.forEach(item => {
            configDetailsArray.push(this.formBuilder.group({
                title: [item.title],
                code: [item.code],
                ischecked: [false]
            }))
        })
    }

    bindConfig() {
        this.configService.GetAll().subscribe((res) => {
            if (res?.success) {
                const invoiceconfig: any = res?.data[0]?.invoiceconfig ?? [];
                const configDetailsArray = this.configForm.get('configDetails') as FormArray;
                const configDetailMap = new Map(this.configDetail.map((configItem, index) => [configItem.code, index]));
                for (let key in invoiceconfig) {
                    const detailIndex: any = configDetailMap.get(key);
                    if (detailIndex !== undefined) {
                        const detailFormGroup = configDetailsArray.at(detailIndex) as FormGroup;
                        detailFormGroup.patchValue({ ischecked: invoiceconfig[key] });
                    }
                }
            }
        })
    }

    editAction(cell: any) {
        if (cell.id) {
            // console.log(cell);
            this.irnId = cell.id;
            this.isEditIrnMode = true;
            this.invoiceIRNForm.patchValue({
                ddlBillTo: cell.billto,
                ddlCompany: cell?.companyid,
                ddlServiceCenter: cell?.servicecenterid,
                txtUserId: cell.userid,
                txtPassword: cell.password
            });
            this.onBillToChange();
        }
    }

    onChangeCompany() {
        if (this.companyList.find(x => x.id == this.invoiceFormatsForm.get('ddlCompany').value)?.billto == 'Company') {
            this.isInvoiceBillingToSC = false;
            this.invoiceFormatsForm.get('ddlServiceCenter').clearValidators();
        } else {
            this.isInvoiceBillingToSC = true;
            this.invoiceFormatsForm.get('ddlServiceCenter').setValidators([Validators.required]);
        }
        this.invoiceFormatsForm.get('ddlServiceCenter').updateValueAndValidity();
    }

    onBillToChange() {
        if (this.invoiceIRNForm.get('ddlBillTo').value === this.billToList[0].name) {
            this.isIRNBillingToCompany = true;
            this.invoiceIRNForm.get('ddlCompany').setValidators([Validators.required])
            this.invoiceIRNForm.get('ddlServiceCenter').clearValidators()
        } else {
            this.isIRNBillingToCompany = false;
            this.invoiceIRNForm.get('ddlServiceCenter').setValidators([Validators.required])
            this.invoiceIRNForm.get('ddlCompany').clearValidators()
        }
        this.invoiceIRNForm.get('ddlCompany').updateValueAndValidity()
        this.invoiceIRNForm.get('ddlServiceCenter').updateValueAndValidity()
    }

    GetAllIrnConfig() {
        this.ngxLoaderService.start();
        try {
            this.invoiceService.GetAllIrnConfig().subscribe(res => {
                if (res?.success) {
                    this.ngxLoaderService.stop();
                    this.rowDataIRN = res.data.map(x => ({
                        ...x,
                        servicecenter: x.servicecenterid === null ? '-' : x.servicecenter,
                        company: x.companyid === null ? '-' : x.company,
                        edit: true
                    }))
                }
            })
        } catch (error) {
            this.ngxLoaderService.stop();
        }
    }

    upsertIrnList() {
        this.irnFromSubmitted = true;
        let reqObj: any;
        if (this.invoiceIRNForm.valid) {
            reqObj = {
                id: this.irnId,
                vendor: 'Charted',
                billTo: this.invoiceIRNForm.get('ddlBillTo').value,
                companyId: this.invoiceIRNForm.get('ddlCompany').value,
                serviceCenterId: this.invoiceIRNForm.get('ddlServiceCenter').value,
                userId: this.invoiceIRNForm.get('txtUserId').value,
                password: this.invoiceIRNForm.get('txtPassword').value
            }
            // console.log('reqObj:', reqObj);
        } else return;
        if (this.isEditIrnMode) {
            reqObj.companyId = this.isIRNBillingToCompany ? reqObj.companyId : null;
            reqObj.serviceCenterId = !this.isIRNBillingToCompany ? reqObj.serviceCenterId : null;
            this.ngxLoaderService.start();
            try {
                this.invoiceService.UpdateIrnConfig(reqObj).subscribe(res => {
                    if (res) {
                        if (!res.success && res?.data?.err_msg) {
                            this.ngxLoaderService.stop();
                            this.appCoreService.showMessage(res.data.err_msg, 'Error', 'error');
                        }
                        if (res.success) {
                            this.ngxLoaderService.stop();
                            this.appCoreService.showMessage('Record saved successfully', 'Success', 'success');
                            this.GetAllIrnConfig();
                            this.resetIRNForm();
                        }
                    }

                })
            } catch (error) {
                this.ngxLoaderService.stop();
            }
        }
        else {
            this.ngxLoaderService.start();
            try {
                this.invoiceService.AddIrnConfig(reqObj).subscribe(res => {
                    if (res) {
                        if (!res.success && res?.data?.err_msg) {
                            this.ngxLoaderService.stop();
                            this.appCoreService.showMessage(res.data.err_msg, 'Error', 'error');
                        }
                        if (res.success) {
                            this.ngxLoaderService.stop();
                            this.appCoreService.showMessage('Record saved successfully', 'Success', 'success');
                            this.GetAllIrnConfig()
                            this.resetIRNForm();
                        }
                    }
                })
            } catch (error) {
                this.ngxLoaderService.stop();
            }

        }
    }
    onCheckBoxChange(event: any) {
        if ((this.activeInvoiceSeriesId != event.rowdata.id) && event?.checked) {
            this.invoiceService.UpdateStatus({
                id: event.rowdata.id,
                isactive: event?.checked,
                invoicetype: event.rowdata.invoicetype,
                companyid: event.rowdata?.companyid,
                servicecenterid: event.rowdata?.servicecenterid
            }).subscribe(res => {
                if (res && res.success) {
                    this.bindInvoiceSeries();
                    this.appCoreService.showMessage('Record Sucessfully Updated');
                } else if (res && !res?.success) {
                    this.appCoreService.showMessage('API processing Error', '', 'error');
                }
            });
        } else {
            this.appCoreService.showMessage('Cannot Inactivate. Atleast One record should be active', '', 'error');
        }
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData(); 
        const permission = userData.config.filter(x => x.categoryname === 'InvoiceSeries');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    bindInvoiceType() {
        const userData = this.appCoreService.GetUserData();
        const categoryName = userData.config.map(x => x.categoryname);
        const availableInvoiceTypes = ['Sales', 'Supplementary', 'Debit Note', 'Credit Note'];
    
        this.invoiceTypeList = availableInvoiceTypes.filter(type => 
            categoryName.includes(type) || categoryName.includes('Debit/Credit Note') && (type === 'Debit Note' || type === 'Credit Note')
        );
    }
    

    bindInvoiceSeries(refresh = false) {
        try {
            this.ngxLoaderService.start();
            this.invoiceService.GetAllSeries({refresh: refresh}).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.invoiceRowData = res.data;
                    this.activeInvoiceSeriesId = this.invoiceRowData.length ? this.invoiceRowData.find(x => x.isactive).id : null;
                }
            });
        } catch (e) {
            this.ngxLoaderService.stop();
        }
    }

    addCustomValidator() {
        const code = this.invoiceFormatsForm.get('invoiceConfigForm.ddlCode').value;
        if (code == "Custom") {
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').clearValidators();
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').addValidators([Validators.maxLength(6), Validators.required]);
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').updateValueAndValidity();
        }
        else {
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').clearValidators();
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').addValidators([Validators.maxLength(6)]);
            this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom').updateValueAndValidity();
        }
    }

    async addInvoiceSeries() {
        this.isFormSubmitted = true;
        if (this.invoiceFormatsForm.invalid) {
            if (!this.invoiceFormatsForm.get('txtStartFrom').value) {
                return;
            }
        }
        if (this.invoiceConfigData.length < 1) {
            this.warningDialog("Atleast one prefix or suffix need to be added.");
            return;
        }

        const data = {
            invoicetype: this.invoiceFormatsForm.get('ddlInvoiceType').value,
            startfrom: this.invoiceFormatsForm.get('txtStartFrom').value,
            isactive: this.invoiceFormatsForm.get('txtActive').value,
            companyid: this.invoiceFormatsForm.get('ddlCompany')?.value,
            servicecenterid: this.invoiceFormatsForm.get('ddlServiceCenter')?.value,
            config: this.invoiceConfigData
        }
        const userData = {
            companycode: this.companyList.find(x => x.isdefault)?.code,
            servicecentercode: this.appCoreService.GetUserData()?.servicecenters?.find(sc => sc.isdefault)?.code,
            countrycode: this.appCoreService.GetUserData().metaInfo.defaultcountry
        }
        const invoicenofull = await this.GenerateInvoiceNo(data.config, data.startfrom, userData);
        if (invoicenofull.length >= 16) {
            Swal.fire({
                html: `<span>Invalid Generated Series</span><br><u><b>${invoicenofull}</b></u><br><span>cannot exceed 16 characters.</span>`,
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        } else {
            //check for confirmation 
            if (data.isactive && this.invoiceRowData.some(x => x.invoicetype == data.invoicetype && x.isactive)) {
                const result = await this.openConfirmationDialog('Already active series present. Do you want to Activate this series ?');
                data.isactive = result.confirmed ? true : false;
            }
            this.ngxLoaderService.start();
            this.invoiceService.AddSeries(data).subscribe((res) => {
                if (res) {
                    this.ngxLoaderService.stop();
                    if (!res.success && res.err_msg) {
                        return this.appCoreService.showMessage(res.err_msg, 'Duplication Error', 'error')
                    }
                    if (res.success) {
                        this.appCoreService.showMessage(`Record Added Successfully`, 'Success', 'success');
                        this.resetForm();
                        this.resetConfigForm();
                        this.bindInvoiceSeries();
                    }
                    if (!res.success) {
                        const msg = res.message.split('.');
                        if (msg.length) {
                            Swal.fire({
                                title: 'Warning!',
                                html: `<span>${msg[0]}</span><br><span>${msg[1]}</span>`,
                                icon: 'warning',
                                confirmButtonText: 'OK'
                            });
                        }
                    }
                }
            });
        }
        this.ngxLoaderService.stop();
    }

    async GenerateInvoiceNo(seriesArray: any, startsFrom: string, userData: any) {
        const companycode = userData?.companycode;
        const servicecentercode = userData?.servicecentercode;
        const countrycode = userData?.countrycode;
        const currentYear = new Date().getFullYear();
        const lastestinvoiceno = startsFrom;

        let _prefix: string = "";
        let _suffix: string = "";

        // Construct prefix string
        seriesArray
            .filter((config: any) => config.configtype === 'Prefix')
            .sort((a: any, b: any) => a.sequence - b.sequence)
            .forEach((x: any) => {
                switch (x.code) {
                    case "Company Code":
                        _prefix += `${companycode}${x.separator}`;
                        break;
                    case "ServiceCenter Code":
                        _prefix += `${servicecentercode}${x.separator}`;
                        break;
                    case "Country Code":
                        if (countrycode) _prefix += `${countrycode}${x.separator}`;
                        break;
                    case "Year":
                        if (currentYear) _prefix += `${currentYear}${x.separator}`;
                        break;
                    case "Custom":
                        if (x.customvalue) _prefix += `${x.customvalue}${x.separator}`;
                        break;
                }
            });

        // Construct suffix string
        seriesArray
            .filter((config: any) => config.configtype === 'Suffix')
            .sort((a: any, b: any) => a.sequence - b.sequence)
            .forEach((x: any) => {
                switch (x.code) {
                    case "Company Code":
                        _suffix += `${x.separator}${companycode}`;
                        break;
                    case "ServiceCenter Code":
                        _suffix += `${x.separator}${servicecentercode}`;
                        break;
                    case "Country Code":
                        if (countrycode) _suffix += `${x.separator}${countrycode}`;
                        break;
                    case "Year":
                        if (currentYear) _suffix += `${x.separator}${currentYear}`;
                        break;
                    case "Custom":
                        if (x.customvalue) _suffix += `${x.separator}${x.customvalue}`;
                        break;
                }
            });

        // Return the full invoice number
        return `${_prefix}${lastestinvoiceno}${_suffix}`;
    }


    addInvoiceConfig() {
        this.isInvoiceConfigFormSubmitted = true;
        const invoiceConfigForm = this.invoiceFormatsForm.get('invoiceConfigForm');
        const lastId = this.invoiceConfigData.length > 0 ? this.invoiceConfigData[this.invoiceConfigData.length - 1].id : 0;

        if (invoiceConfigForm.valid) {
            const reqObj = {
                id: lastId + 1,
                configtype: this.invoiceFormatsForm.get('invoiceConfigForm.ddlConfig')?.value,
                code: this.invoiceFormatsForm.get('invoiceConfigForm.ddlCode')?.value,

                customvalue: this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom')?.value &&
                    this.invoiceFormatsForm.get('invoiceConfigForm.ddlCode')?.value == "Custom" ?
                    this.invoiceFormatsForm.get('invoiceConfigForm.txtCustom')?.value : null,

                separator: this.invoiceFormatsForm.get('invoiceConfigForm.ddlSeparator')?.value,
                sequence: parseInt(this.invoiceFormatsForm.get('invoiceConfigForm.ddlSequence')?.value),
            }

            if (!this.checkInvoiceConfig(reqObj)) {
                return;
            }
            this.filterData(reqObj)
            this.appCoreService.showMessage(`Record Added Successfully`, 'Success', 'success');
            this.resetConfigForm();

        }
    }

    checkInvoiceConfig(reqObj: any) {
        const Prefix = this.invoiceConfigData.filter((item) => item.configtype == "Prefix");
        const Suffix = this.invoiceConfigData.filter((item) => item.configtype == "Suffix");

        if (Prefix.length >= 3 && reqObj.configtype == "Prefix") {
            this.appCoreService.showMessage(`Upto three configuration can be Added`, 'Warning', 'warning');
            return false;
        }
        if (Suffix.length >= 3 && reqObj.configtype == "Suffix") {
            this.appCoreService.showMessage(`Upto three configuration can be Addeds`, 'Warning', 'warning');
            return false;
        }

        const isExist = this.invoiceConfigData.some(
            (item) => item.sequence == reqObj.sequence && item.configtype == reqObj.configtype
        );

        if (isExist) {
            this.appCoreService.showMessage(`Sequence No Already Taken`, 'Warning', 'warning');
            return false;
        }
        return true;
    }

    filterData(data?: any) {
        if (data) {
            this.invoiceConfigData = [...this.invoiceConfigData, data];
        }
        const configType = this.invoiceFormatsForm.get('invoiceConfigForm.ddlConfig').value;
        this.invoiceConfigRowData = this.invoiceConfigData.filter((item) => item.configtype == configType).sort((a, b) => a.sequence - b.sequence);
        this.invoiceConfigRowData.length? this.invoiceFormatsForm.get('ddlInvoiceType').disable(): null;
    }

    deleteRecord(data: any) {
        if (data?.startfrom || data?.prefix) {
            this.ngxLoaderService.start();
            this.invoiceService.DeleteSeries(data.id).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.appCoreService.showMessage('Record Deleted Successfully.', 'Success', 'success');
                    this.bindInvoiceSeries(true);
                    this.resetForm();
                    this.resetConfigForm();
                }
            });
            this.ngxLoaderService.stop();
        }
        else {
            this.invoiceConfigData = this.invoiceConfigData.filter((item) => item.id !== data.id);
            this.filterData();
            this.appCoreService.showMessage(`Record Deleted Successfully.`, 'Success', 'success');
            this.resetConfigForm();
        }
    }

    async deleteAction(cell: any) {
        if (!this.permConfig.isDeleteAllowed) {
            this.warningDialog('No access to Delete.');
        }
        else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
            const result = await this.openConfirmationDialog('Are you sure you want to delete ?');
            if (result.confirmed) {
                // console.log('this.activeTab', this.activeTab);

                if (this.activeTab == 1) {
                    if (this.invoiceRowData.find(x => x.id == cell.id && cell.isactive == true)) {
                        this.appCoreService.showMessage('Active Series Cannot be deleted. Please deactivate it if you wish so.', 'Error', 'error')
                    } else {
                        this.deleteRecord(cell);
                    }
                } else {
                    this.ngxLoaderService.start();
                    try {
                        this.invoiceService.DeleteIrnConfigById(cell.id).subscribe(res => {
                            if (res?.success) {
                                this.GetAllIrnConfig();
                                this.ngxLoaderService.stop();
                                this.appCoreService.showMessage('Record deleted successfully', 'Success', 'success')
                            }
                        })
                    } catch (error) {
                        this.ngxLoaderService.stop();
                    }

                }
            }
        }
    }

    async openConfirmationDialog(msg: any) {
        const result = await Swal.fire({
            // titleText: 'Confirmation',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Yes',
            showDenyButton: true,
            denyButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            return { confirmed: true }; // Return true if confirmed
        }
        return { confirmed: false }; // Return false if denied or closed
    }


    warningDialog(msg: any) {
        Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });

    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    resetForm() {
        this.invoiceFormatsForm.reset();
        this.invoiceFormatsForm.get('txtActive').setValue(true);
        this.isFormSubmitted = false;
        this.invoiceConfigData = [];
        this.isInvoiceBillingToSC = false;
        this.invoiceFormatsForm.get('ddlInvoiceType').enable()
    }

    resetConfigForm() {
        const configType = this.invoiceFormatsForm.get('invoiceConfigForm.ddlConfig')?.value || "Prefix";
        this.invoiceFormatsForm.get('invoiceConfigForm').reset();
        this.invoiceFormatsForm.get('invoiceConfigForm.ddlConfig').setValue(configType);
        this.invoiceFormatsForm.get('invoiceConfigForm.ddlCode').setValue('Year');
        this.invoiceFormatsForm.get('invoiceConfigForm.ddlSeparator').setValue('/');
        this.invoiceFormatsForm.get('invoiceConfigForm.ddlSequence').setValue(1);
        this.isInvoiceConfigFormSubmitted = false;
        this.filterData();
        this.addCustomValidator();
    }

    getAllCompanies() {
        try {
            this.companyService.GetAll({ isactive: true }).subscribe((res) => {
                if (res && res.success) {
                    this.companyList = res.data;
                    //select default
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    getAllServiceCenter() {
        try {
            this.networkService.GetAllServiceCenters().subscribe((res) => {
                if (res && res.success) {
                    this.serviceCenterList = this.appCoreService.GetUserData().accessType === 'System'
                        ? res.data
                        : res.data.filter(s => this.appCoreService.GetUserData().servicecenters.some(sc => sc.id == s.id));
                }
            });
        } catch (e) {
            console.error(e);
        }
    }
    resetIRNForm() {
        this.irnFromSubmitted = false;
        this.invoiceIRNForm.reset();
        this.invoiceIRNForm.get('ddlBillTo').setValue(this.billToList[0].name);
        this.isIRNBillingToCompany = true;
        this.isEditIrnMode = false;
        this.invoiceIRNForm.get('txtPassword').setValidators([Validators.required])
    }

    updateConfig() {
        try {
            const formValues = this.configForm.getRawValue();
            const invoiceConfigData = formValues.configDetails.reduce((acc: any, item: any) => {
                acc[item.code] = item.ischecked;
                return acc;
            }, {});

            let reqObj = {
                type: 'invoice',
                configDetails: invoiceConfigData
            }

            this.ngxLoaderService.start();
            this.configService.ManageConfigs(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.appCoreService.showMessage('General Setting Updated successfully', 'Success', 'success')
                    this.ngxLoaderService.stop();
                }
            });
        } catch (e) {
            this.ngxLoaderService.stop();
        }
    }


    get configDetails(): FormArray {
        return this.configForm.get('configDetails') as FormArray;
    }
}